
define('ldsh!modules/form_editor/templates/layout', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container ' +
((__t = ( isAdvancedMode? 'ed-advanced-mode' : 'ed-simple-mode')) == null ? '' : __t) +
'">\n  <div class="ed-modal-header ed-opt-toolbar">\n    <div class="ed-toolgroup js-toolbar"></div>\n    <button class="close js-close" type="button" aria-hidden="true">\n      <i class="ri-close-line"></i>\n    </button>\n  </div>\n  <div class="js-notice"></div>\n  <div class="ed-opt-content-wrapper">\n    <div class="ed-opt-content col one-half ed-item-config js-editor"></div>\n    <div class="ed-opt-content col one-half ed-item-preview js-preview"></div>\n  </div>\n</div>\n';

}
return __p
};});

